import CheckboxWithError from "../CheckboxWithError";
export default {
  permission: {
    InputComponent: CheckboxWithError,
    ignoreCaption: true,
  },
};
